import { cn } from "../../lib/cn";

type Tone = "default" | "queue-ok" | "queue-warning" | "risk-high" | "risk-medium" | "risk-low";

type Props = {
  label: string;
  tone?: Tone;
};

export function StatusPill({ label, tone = "default" }: Props) {
  return <span className={cn("status-pill", tone !== "default" && tone)}>{label}</span>;
}
